import { create } from 'zustand';

/** Ist die Benachrichtigungsliste (F-30) offen? */
export const useGlocke = create<{ offen: boolean; setOffen: (offen: boolean) => void }>((set) => ({
  offen: false,
  setOffen: (offen) => set({ offen }),
}));
